import { render, staticRenderFns } from "./UserAccountTabs.vue?vue&type=template&id=6dbee7f4&"
import script from "./UserAccountTabs.vue?vue&type=script&lang=js&"
export * from "./UserAccountTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports